import '../social_content_parent_comment_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.FacebookContentParentCommentView extends Monitoring.Views.SocialContentParentCommentView

  buildQuery: =>
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    @searchQuery.addContextKind('parent_comment')
    @addContextLimit()
    @searchQuery.addContentId(@immediateParentId)
